package kz.dentalcrm.app.screens.diagnosis.list.mvi

import kotlinx.collections.immutable.PersistentList
import kotlinx.collections.immutable.persistentListOf
import kz.dentalcrm.app.core.base.ViewState
import kz.dentalcrm.app.data.network.response_model.diagnosis.Diagnosis

data class DiagnosisViewState(
    val search: String = "",
    val diagnosis: PersistentList<Diagnosis> = persistentListOf(),
    val screenState: ScreenState = ScreenState.Idle
) : ViewState {
    sealed interface ScreenState {
        data object Loading : ScreenState
        data class Error(val text: String) : ScreenState
        data object Idle : ScreenState
    }
}
